import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AllAppsRaw = React.lazy(() => import(/* webpackChunkName: "AdminAAPayrollHistory" */ 'containers/Admin/AAPayrollHistory/AAPayroll'));
export const AdminAAPayrollHistory = () => (React.createElement(Page, { title: "AA Payroll History", description: "AA Payroll History" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AllAppsRaw, null)))));
